import { useQuery } from "@tanstack/react-query";
import { searchProducts } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook للبحث عن المنتجات
 * @param {Object} params - Search parameters
 * @param {string} params.q - Search query (required)
 * @param {number} params.page - Page number
 * @param {number} params.per_page - Items per page
 * @param {string} params.department_slugs - Filter by department slugs (comma separated)
 * @param {string} params.category_slugs - Filter by category slugs (comma separated)
 * @param {string} params.brand_slugs - Filter by brand slugs (comma separated)
 * @param {number} params.min_price - Minimum price
 * @param {number} params.max_price - Maximum price
 */
export function useSearchProducts(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["searchProducts", i18next.language, params],
        queryFn: () => searchProducts(params),
        retry: false,
        // Remove enabled: !!params.q to allow browsing
    });

    const searchResults = data?.data?.data?.products || [];
    const pagination = data?.data?.meta || null;

    return { isLoading, error, searchResults, pagination, refetch };
}
